import React from "react";
import { VegaForm,VegaFlex,VegaInput,VegaTextarea,VegaAccordion,VegaText, VegaButtonLink} from "@heartlandone/vega-react";

function Guest({ index, model, removeComponent =(i) => {}, expand, toggleExpand}) {
  return (
    <VegaForm data-vega-form={"guest"+ index +''}>
      <VegaAccordion
        drawsBackground={false}
        expandIconAlign={`left`}
        expand={expand}
        key={"guest"+ index +''}
        onVegaExpand={()=> {toggleExpand()}}
        iconPosition="center"
      >
        <div slot="title">
          <VegaFlex gap="size-24" justifyContent={'space-between'} alignItems={'center'}>
            <VegaText> Guest {index} </VegaText>
            <VegaButtonLink
              icon="fa-regular fa-trash"
              onVegaClick={() => removeComponent(index)}
            />
          </VegaFlex>
        </div>
        <div slot="content">
          <VegaFlex direction={'col'} gap={'size-24'}>
            <VegaFlex gap="size-24"> 
              <VegaInput 
                label="Name"
                size="small" 
                data-vega-form={"name" } 
                value = {(model?.name)? model?.name : ''}
                onVegaChange={e=>{model.name= e.detail}}
                required={true}
              />
              <VegaInput 
                label="Native Name" 
                size="small"
                value = {(model?.nativeName)? model?.nativeName : ''}
                data-vega-form={"nativeName"}
                onVegaChange={e=>{model.nativeName= e.detail}}
              />                       
            </VegaFlex>
            <VegaFlex gap="size-24">
                <VegaInput
                  label="Phone Number" size="small" 
                  data-vega-form={"phone"} 
                  value = {!!(model?.phone)? model?.phone : ''}
                  onVegaChange={e=>{model.phone= e.detail}}
                  required={true}
                />  
                <VegaInput label="Email" 
                  size="small"
                  type="email" 
                  data-vega-form={"email"} 
                  value = {!!(model?.email)? model?.email : ''}
                  onVegaChange={e=>{model.email= e.detail}}
                />  
            </VegaFlex>
            <VegaFlex gap="size-24" alignItems={"end"}>
              <VegaTextarea label="Note" 
                size="small"
                maxLength={255}
                data-vega-form={"note"} 
                value = {!!(model?.note)? model?.note : ''}  
                onVegaChange={e=>{model.note= e.detail}}
              />
            </VegaFlex>
          </VegaFlex>
          
        </div>
      </VegaAccordion>
    </VegaForm>
  );
}

export default Guest;
